"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "darfo-boario-terme": {
    "2976922f": [{
      "hkey": "502ac7d9",
      "slug": "boario-terme",
      "name": "Boario Terme",
      "primary": true,
      "skipSearch": false
    }],
    "angone": [{
      "hkey": "502ac7d9",
      "slug": "boario-terme",
      "name": "Boario Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "darfo-boario-terme"
    }],
    "9f6b0fcc": [{
      "hkey": "30af0f2a",
      "slug": "darfo-boario-terme",
      "name": "Darfo Boario Terme",
      "primary": true,
      "skipSearch": false
    }],
    "bessimo-inferiore": [{
      "hkey": "30af0f2a",
      "slug": "darfo-boario-terme",
      "name": "Darfo Boario Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "92a59a4d": [{
      "hkey": "502ac7d9",
      "slug": "boario-terme",
      "name": "Boario Terme",
      "primary": true,
      "skipSearch": false
    }],
    "erbanno": [{
      "hkey": "502ac7d9",
      "slug": "boario-terme",
      "name": "Boario Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "darfo-boario-terme"
    }],
    "419eac21": [{
      "hkey": "cef35425",
      "slug": "darfo",
      "name": "Darfo",
      "primary": true,
      "skipSearch": false
    }],
    "fucine": [{
      "hkey": "cef35425",
      "slug": "darfo",
      "name": "Darfo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "darfo-boario-terme"
    }],
    "cfc8320b": [{
      "hkey": "502ac7d9",
      "slug": "boario-terme",
      "name": "Boario Terme",
      "primary": true,
      "skipSearch": false
    }],
    "gorzone": [{
      "hkey": "502ac7d9",
      "slug": "boario-terme",
      "name": "Boario Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "darfo-boario-terme"
    }],
    "1389e1da": [{
      "hkey": "cef35425",
      "slug": "darfo",
      "name": "Darfo",
      "primary": true,
      "skipSearch": false
    }],
    "montecchio": [{
      "hkey": "cef35425",
      "slug": "darfo",
      "name": "Darfo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "darfo-boario-terme"
    }],
    "6e28a579": [{
      "hkey": "cef35425",
      "slug": "darfo",
      "name": "Darfo",
      "primary": true,
      "skipSearch": false
    }],
    "pellalepre": [{
      "hkey": "cef35425",
      "slug": "darfo",
      "name": "Darfo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "darfo-boario-terme"
    }]
  }
};
exports["default"] = _default;